import * as React from "react"

export const QuizQuestionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10.417 17.779.08-1.696H10q-2.746 0-4.665-1.916-1.918-1.917-1.918-4.662t1.92-4.667 4.667-1.921q1.374 0 2.57.52 1.194.52 2.082 1.407a6.7 6.7 0 0 1 1.408 2.084q.52 1.196.52 2.572 0 1.293-.547 2.515-.546 1.222-1.424 2.297a13.4 13.4 0 0 1-1.979 1.962 15.5 15.5 0 0 1-2.217 1.505m1.083-1.946a12.9 12.9 0 0 0 2.834-2.906Q15.5 11.27 15.5 9.5q0-2.272-1.614-3.886T10 4Q7.73 4 6.115 5.614 4.5 7.23 4.5 9.5t1.615 3.885T10 15h1.5zm-1.476-2.501q.298 0 .506-.208a.69.69 0 0 0 .208-.506.69.69 0 0 0-.208-.505.69.69 0 0 0-.506-.208.69.69 0 0 0-.505.208.69.69 0 0 0-.208.505q0 .298.208.506a.69.69 0 0 0 .505.207m-.484-2.438h.952q.016-.486.12-.79.103-.306.475-.678.367-.345.722-.71.354-.363.355-1.085 0-.92-.619-1.453-.618-.534-1.529-.534-.8 0-1.351.456a2.55 2.55 0 0 0-.78 1.05l.85.363a1.7 1.7 0 0 1 .426-.655q.297-.292.855-.292.635 0 .923.348.29.348.289.743 0 .47-.306.775-.306.307-.684.664-.479.452-.588.845-.11.393-.11.953"
    ></path>
  </svg>
)
